import { render, staticRenderFns } from "./DadosProfissionaisComponent.vue?vue&type=template&id=56248680"
import script from "./DadosProfissionaisComponent.vue?vue&type=script&lang=js"
export * from "./DadosProfissionaisComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports